export default __webpack_public_path__ + "static/media/home-decor-img-04.610b85e7.png";